import { gql } from '@apollo/client';

export const CREATE_CREDIT_APPRAISAL = gql`
    mutation($companyNumber: String!) {
        createCreditAppraisal(companyNumber: $companyNumber) {
            id
        }
    }
`;
